export const BLASTDOG_DATASET_NAME = "BLASTDOG";
export const IOGAS_GROUP_NAME = "ioGAS";
export const BlockSortOrder = [
	// Requested order as per MPD-2340
	"Planned Collar",
	"Planned Survey",
	"Drilled Collar",
	"Drilled Survey",
	"Logged Collar",
	"Logged Survey",
	"Actual Collar",
	"Actual Survey",
	"Points",
	"Intervals",
	"Top of coal picks",
	"Bottom of coal picks",
	"Water level picks",
	// order to handle custom values of Blastdog YAML config (need to request Muthu to update to match MPD-2340)
	"Hole Survey Aggregated 1m",
	"Rock Type Cluster Points",
	"Coal top", // n/a anymore unless we remove the " picks" append on picks displayName
	"Coal bottom",
	"Coal top picks",
	"Coal bottom picks",
	"Water Level picks",
	"Slicing"
	// end placeholders from yaml
];

export const NonDrillholeLayerConfigType = "default";
export const CollarDrillholeLayerConfigType = "collar";
// export const SurveyDrillholeLayerConfigType = "survey"; // unused
// export const PointsLayerConfigType = "points";
// export const IntervalsLayerConfigType = "intervals";

export const loadSaveFilterIdPrefix = "9990"; // prefix for id of filters loaded from save state; the id no longer exiss
